import React from 'react';
import MarketingLayout from '../components/MarketingLayout';
import { Link } from 'react-router-dom';
import '../marketing.css';

const MarketingHome = () => {
  return (
    <MarketingLayout>
      {/* Hero Section */}
      <section className="hero">
        <div className="hero-decorative-circle hero-circle-1"></div>
        <div className="hero-decorative-circle hero-circle-2"></div>
        <div className="hero-decorative-circle hero-circle-3"></div>
        <div className="container">
          <div className="hero-content">
            <h1 className="hero-title">
              Turn Volunteer Time into <span className="highlight">Real-World Impact</span>
            </h1>
            <p className="hero-subtitle">
              PlayBack Token logs and verifies volunteer hours in sports and community clubs. We convert the verified hours into PlayBack Tokens, which can be purchased by companies as part of their Social Impact Spending.
            </p>
            <div className="hero-buttons">
              <Link to="/clubs" className="btn btn-large btn-primary">For Community Clubs</Link>
              <Link to="/companies" className="btn btn-large btn-outline">For Companies</Link>
            </div>
          </div>
        </div>
      </section>

      {/* How It Works */}
      <section className="how-it-works">
        <div className="container">
          <h2 className="section-title">How PlayBack Token Works</h2>
          <p className="section-subtitle">A simple, transparent system that benefits everyone</p>
          
          <div className="steps">
            <div className="step">
              <div className="step-card">
                <div className="step-badge">Step 1</div>
                <div className="step-icon step-icon-image">
                  <div className="phone-with-screen">
                    <img src="https://images.unsplash.com/photo-1691256676376-357c3aa66c89?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzR8MHwxfHNlYXJjaHwxfHxoYW5kJTIwc21hcnRwaG9uZXxlbnwwfHx8fDE3NjIyNjIwNTV8MA&ixlib=rb-4.1.0&q=85&w=400" alt="Hand holding smartphone" className="step-phone-image" />
                    <img src="data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 200 400'%3E%3Crect fill='%23dc2626' width='200' height='60'/%3E%3Ctext x='100' y='35' font-family='Arial' font-size='16' fill='white' text-anchor='middle'%3ELog Your Hours%3C/text%3E%3Crect fill='white' y='60' width='200' height='340'/%3E%3Ctext x='20' y='90' font-family='Arial' font-size='10' fill='%23666'%3EDate%3C/text%3E%3Crect fill='%23f3f4f6' x='20' y='95' width='160' height='25' rx='4'/%3E%3Ctext x='20' y='135' font-family='Arial' font-size='10' fill='%23666'%3EStart Time%3C/text%3E%3Crect fill='%23f3f4f6' x='20' y='140' width='160' height='25' rx='4'/%3E%3Ctext x='20' y='180' font-family='Arial' font-size='10' fill='%23666'%3EHours%3C/text%3E%3Crect fill='%23f3f4f6' x='20' y='185' width='160' height='25' rx='4'/%3E%3Ctext x='20' y='225' font-family='Arial' font-size='10' fill='%23666'%3EActivity Type%3C/text%3E%3Crect fill='%23f3f4f6' x='20' y='230' width='160' height='25' rx='4'/%3E%3Ctext x='20' y='270' font-family='Arial' font-size='10' fill='%23666'%3EDescription%3C/text%3E%3Crect fill='%23f3f4f6' x='20' y='275' width='160' height='60' rx='4'/%3E%3Crect fill='%23dc2626' x='50' y='355' width='100' height='30' rx='6'/%3E%3Ctext x='100' y='375' font-family='Arial' font-size='12' fill='white' text-anchor='middle'%3ESubmit%3C/text%3E%3C/svg%3E" alt="App screen" className="phone-screen-overlay" />
                  </div>
                </div>
                <h3>Volunteers Log Hours</h3>
                <p>Club volunteers track their time using our easy to use, secure mobile app.</p>
              </div>
              <div className="step-connector">→</div>
            </div>
            
            <div className="step">
              <div className="step-card">
                <div className="step-badge">Step 2</div>
                <div className="step-icon step-icon-image">
                  <img src="https://customer-assets.emergentagent.com/job_volunteer-hub-35/artifacts/5ta1s578_playback%20logo.jpg" alt="PlayBack Token" className="step-logo-image" />
                </div>
                <h3>Hours Become Tokens</h3>
                <p>Each verified hour is converted into a unique PlayBack Token with complete traceability.</p>
              </div>
              <div className="step-connector">→</div>
            </div>
            
            <div className="step">
              <div className="step-card">
                <div className="step-badge">Step 3</div>
                <div className="step-icon step-icon-image">
                  <img src="https://customer-assets.emergentagent.com/job_impact-tokens/artifacts/0hoblwul_ChatGPT-Image-May-28-2025-03_26_56-PM-768x512.png" alt="Corporate partnership" className="step-photo-image" />
                </div>
                <h3>Companies Purchase Tokens</h3>
                <p>Corporates buy PlayBack Tokens for Social Impact funding as part of ESG & CSR requirements. Money flows directly into club bank account.</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Who It's For */}
      <section className="who-its-for">
        <div className="container">
          <h2 className="section-title">Who It's For</h2>
          <p className="section-subtitle">Empowering three key stakeholders in the social impact ecosystem</p>
          
          <div className="audience-grid">
            <div className="audience-card">
              <div className="audience-badge">For Clubs</div>
              <div className="audience-image">
                <img src="https://customer-assets.emergentagent.com/job_impact-tokens/artifacts/vyve1fss_Untitled%20design%20%2868%29.png" alt="Youth sports teams" />
              </div>
              <h3>Sports & Community Clubs</h3>
              <p>Monetize your volunteer foundation. Track hours, get verified, receive corporate funding.</p>
              <Link to="/clubs" className="audience-cta-btn">Learn More →</Link>
            </div>
            
            <div className="audience-card">
              <div className="audience-badge">For Volunteers</div>
              <div className="audience-image">
                <img src="https://customer-assets.emergentagent.com/job_impact-tokens/artifacts/n6apw2x7_Line-Marking-Product-Finder-Council.webp" alt="Sports volunteer maintaining field" />
              </div>
              <h3>Volunteers</h3>
              <p>Your time matters. Log hours easily, get verified, and directly support your club's funding.</p>
              <Link to="/clubs" className="audience-cta-btn">Join as Volunteer →</Link>
            </div>
            
            <div className="audience-card">
              <div className="audience-badge">For Companies</div>
              <div className="audience-image">
                <img src="https://customer-assets.emergentagent.com/job_impact-tokens/artifacts/rbxq6tl9_MicrosoftTeams-image-20.webp" alt="Corporate ESG team meeting" />
              </div>
              <h3>Corporate ESG Teams</h3>
              <p>Purchase verified volunteer hours for measurable, transparent ESG impact and compliance.</p>
              <Link to="/companies" className="audience-cta-btn">Explore ESG Solutions →</Link>
            </div>
          </div>
        </div>
      </section>
    </MarketingLayout>
  );
};

export default MarketingHome;
